/* eslint-disable */
import { mapGetters } from 'vuex';
import { getRoundCard, saveManageMsg, getDetailsTmptDef, getManageDetails, publishManageMsg, publishBidPrice, matchStandardCosts,
    nextTender, bidWonRw, wonOpenAll, cancelRw, WonZb, wonGiveUp, saveDetailsMsg, bidDelOneRound, bidPriceCheck, getCountDown, exportBidTender,
    checkDtlDetailTiedFirst,
} from '../../../api/tenderDetails.js';
import bigDataLog from '@/utils/bigDataLog';
import { dictWithUrl } from '@/components/lots/api';
import MSelect from '@/components/lots/otpSelect2';
import addTimeDialog from './addTimeDialog.vue';
import batchBidDialog from './batchBidDialog.vue';
import { tenderEnquiry } from '../../../api/tenderEnquiry';
import autoShortlistDialog from './autoShortlistDialog.vue';
import wonFailedDialog from './wonFailedDialog.vue';
import consultCostDialog from './consultCostDialog.vue';
import customAdvance from '@/components/lots/otpAdvanceDialog';
import roundWarning from './roundWarning.vue';
import config from '@/config/user.env';
import roundTable from './roundTable.vue';
import { roundQuoteData } from './roundQuoteConfig';
import SeeOfferDialog from '../myTender/seeOfferDialog.vue';
import Addsupplier from './Addsupplier.vue';
import { customConfig } from './advanceConfig';
import { ruleConfig, effectDateFrom, countTimeSet, timeStr, parFn, formatData } from './commrule.js';
import Cookies from 'js-cookie';
import { logout } from '@/utils/index';
import { TENDER_STATUS, BID_STATUS, TENDER_TYPE, LOWER_LAST_ROUND, BUSINESS_TYPE } from './constant.js';
import { TRANSPORTATION_NUM, DELIVERY_NUM, EXPRESS_NUM, HOME_DELIVERY_NUM } from '../../../constant/constant.js';
export default {
    components: { Addsupplier, SeeOfferDialog, addTimeDialog, batchBidDialog, autoShortlistDialog, wonFailedDialog, MSelect, roundTable, roundWarning, consultCostDialog, customAdvance },
    data () {
        const effectDateTo = (rule, value, callback) => {
            const date = new Date(this.form.effectDateFrom);// 获取开始时间戳
            const time = date.getTime();
            const timestamp = new Date(value).getTime(); // 获取的结束时间戳
            if (!value) {
                callback(new Error('请输入洽谈结束时间'));
            } else if (timestamp - time <= 0) {
                callback(new Error('不能小于开始时间'));
            } else { callback(); }
        };
        return {
            TENDER_STATUS,
            BID_STATUS,
            TENDER_TYPE,
            LOWER_LAST_ROUND,
            BUSINESS_TYPE,
            pickerOptionsStart: { disabledDate: time => { return time.getTime() < new Date(new Date().toLocaleDateString()).getTime(); } },
            rules: {
                effectDateFrom: [{ required: true, validator: effectDateFrom, trigger: ['blur'] }],
                effectDateTo: [{ required: true, validator: effectDateTo, trigger: ['blur'] }],
                ...ruleConfig
            },
            iflowId: this.$route.query.mbpmFlowId,
            ...roundQuoteData
        };
    },
    beforeDestroy() {
        this.websock && this.websock.close();
        this.setIntervalTime && clearTimeout(this.setIntervalTime); // 倒计时计时器
        this.resetInter(); // 心跳检测定时器
    },
    methods: {
        AddsupplierFn() {
            this.showAddSupplier = true
        },
        seeFunc() { this.seeOfferVisible = true; },
        warnShowFunc (val) { this.warnShowFlag = val; },
        earlyWarning () { this.warnShowFlag = true; },
        delOneRound () {
            this.$prompt('删除第一轮理由', '删除第一轮确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValidator: this.privilegeRules,
                inputErrorMessage: '请输入删除第一轮理由'
            }).then(async ({ value }) => {
                const url = `?specialChange=Y&changeSeq=${new Date().getTime() + this.bidNo}&changeReson=${value}`;
                const res = await bidDelOneRound({ bidNo: this.bidNo }, url);
                if (res && res.code === '0') {
                    this.$message.success('操作成功');
                    this.$router.push({ name: 'supplierbid', query: { bidNo: this.bidNo, mbpmFlowId: this.iflowId } });
                    this.$store.dispatch('getGeneAction', { bidNo: this.$route.query.bidNo, iflowId: this.iflowId });
                }
            });
        },
        privilegeRules (val) { if (!val) { return false; } else { return true; } },
        countTime() {
            // 轮次状态：已发布，洽谈类型：竞拍报价
            if (this.form.tenderStatus === this.TENDER_STATUS['PUBILSH'] && this.form.quoteType === this.TENDER_TYPE['BIDDING']) {
                this.getCountDownFunc();
                this.websock && this.websock.close();
                this.initWebSocket();
            } else {
                this.websock && this.websock.close();
            }
        },
        setCountTime() {
            this.setIntervalTime = setTimeout(() => {
                this.cuuntdownSeconds--;
                this.countTimes = countTimeSet(this.cuuntdownSeconds);
                if (this.cuuntdownSeconds <= 0) {
                    this.getData('NEXTROUND');
                    clearTimeout(this.setIntervalTime);
                    return;
                }
                this.setCountTime();
            }, '1000');
        },
        getCountDownFunc() {
            getCountDown({ tenderCode: this.form.tenderCode }).then(res => {
                if (res && res.code === '0') {
                    this.countTimesFlag = true;
                    this.cuuntdownSeconds = res.data / 1000;
                    if (this.cuuntdownSeconds <= 0) {
                        this.countTimes = '已截止';
                        return;
                    }
                    this.setCountTime();
                }
            });
        },
        getData (type) {
            getRoundCard({ iflowId: this.iflowId, bidNo: this.bidNo, 'orderBy': 'roundCurrent', 'orderByType': 'DESC' }).then((res) => {
                if (res && res.code === '0') {
                    this.roundCard = res.data.list;
                    this.roundCard = this.formatData(this.roundCard);
                    this.form = this.roundCard[this.active] || this.form;
                    this.countTime(); // 是否开启倒计时
                    if (this.roundCard.length > 1 && type === 'NEXTROUND') {
                        this.form.blockPriceControl = this.roundCard[this.active + 1].blockPriceControl;
                    }
                    if(this.form.roundCurrent === 1){
                        //第一轮次的【是否控制拦标价】默认为【否】
                        this.form.blockPriceControl = 'N'
                    }
                    this.getTableData();
                    this.btnChange();
                    this.selectAllType = false;
                    if (type) {
                        tenderEnquiry({ bidNo: this.bidNo,iflowId: this.iflowId }).then(res => {
                            if (res && res.code === '0') {
                                this.headerMsg = res.data.list[0];
                                if ((this.headerMsg.quoteRangeVisible !== '5' || this.form.tenderCode) && this.headerMsg.bidStatus === this.BID_STATUS['BIDPUBLISH'] && this.form.roundCurrent !== 1) {
                                    this.bidPriceBtn = false;
                                } else { this.bidPriceBtn = true; }
                                if (this.form.lowerLastRound === null) {
                                    this.form.lowerLastRound = this.headerMsg.lowerLastRound;
                                    this.form.changeBidMin = this.headerMsg.changeBidMin;
                                }
                            }
                        });
                    }
                }
            });
        },
        getTableData () {
            if (this.form.tenderCode) {
                getDetailsTmptDef({ iflowId: this.iflowId, bidNo: this.bidNo, tenderCode: this.form.tenderCode }).then(res => {
                    if (res && res.code === '0') { this.tableHeaders = res.data; }
                });
                this.tableLoad = true;
                getManageDetails({ tenderCode: this.form.tenderCode, allowQuote: this.allowQuote, parent: true }).then(res => {
                    if (res && res.code === '0') {
                        this.tableData = res.data;
                        this.tableLoad = false;
                        this.tableData = this.formatData(this.tableData);
                        this.tableData.forEach((single) => {
                            this.$set(single, 'showSubTable', false);
                        });
                        this.tableIds = this.tableData.map(item => { return { id: item.id } })
                    }
                });
            }
        },
        handScroll (index) {
            this.active = index;
            this.tableData = [];
            this.getData(1);
            this.form = this.roundCard[this.active] || this.form;
            const rotationLeft = this.$refs.rotation.offsetLeft;
            const rotationBoxLeft = this.$refs.rotationBox[index].offsetLeft;
            if (index >= '4' * 1) {
                this.moveX = -(rotationBoxLeft - rotationLeft - '722' * 1);
            } else { this.moveX = 0; }
            this.$refs['ruleForm'].resetFields();
        },
        saveData () { /** 保存 **/
            if (this.form.quoteType === this.TENDER_TYPE['BIDDING'] && this.form.roundCurrent === 1) {
                this.$message.warning("第一轮'洽谈类型'不能为竞拍报价！");
                return;
            }
            this.loadHeadSave = true;
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    saveManageMsg(this.form, this.form.id).then(res => {
                        this.loadHeadSave = false;
                        if (res && res.code === '0') {
                            this.$message.success('保存成功');
                            this.getData();
                        }
                    });
                } else {
                    this.loadHeadSave = false;
                    this.$message.error('请输入完整的信息');
                }
            });
        },
        publishData () { /** 发布 **/
            getRoundCard({ bidNo: this.bidNo, 'orderBy': 'roundCurrent', 'orderByType': 'DESC' }).then((res1) => {
                if (res1 && res1.code === '0') {
                    const obj = res1.data.list[this.active];
                    if (obj.lowerLastRound !== null && obj.effectDateFrom !== null && obj.effectDateTo !== null) {
                        this.publishDataLoad = true;
                        publishManageMsg({ id: this.form.id, version: this.form.version }).then(res2 => {
                            this.publishDataLoad = false;
                            if (res2 && res2.code === '0') {
                                this.getData();
                                this.$message.success('发布成功');
                            }
                        });
                    } else {
                        this.$message.warning('请先保存');
                    }
                }
            });
        },
        addTime () { /** 报价加时 **/
            const startTime = new Date(this.form.effectDateFrom);
            const nowTime = new Date();
            if (startTime.getTime() > nowTime.getTime()) {
                this.$message.warning('还没开始报价，不能加时！');
            } else {
                this.showAddTimeDialog = true;
            }
        },
        tenderResult (name) { /** 查看招标结果 **/
            bigDataLog.sendDetailMessageByKey('bigData-btn-result');
            this.$router.push({ name: name, query: { bidNo: this.bidNo, mbpmFlowId: this.iflowId } });
        },
        bidPrice () { /** 公布拦标价 **/
            const msg = this.form.roundCurrent === 1 ? '第一轮公布栏标价后第一轮轮次报价不能删除，是否确定公布拦标价？' : '是否确定公布拦标价？'
            this.$confirm(msg, '公布拦标价确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.bidPriceLoad = true;
                publishBidPrice({ bidNo: this.bidNo, version: this.headerMsg.version, id: this.headerMsg.id }).then(res => {
                    this.bidPriceLoad = false;
                    if (res && res.code === '0') {
                        this.$message.success('公布成功');
                        this.getData(1);
                    }
                });
            }).catch(() => {});
        },
        nextRound () { /** 发起下一轮 **/
            this.active = 0;
            this.$confirm('结束当前轮次报价，是否发起下一轮', '发起下一轮确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.nextRoundLaod = true;
                nextTender({ bidNo: this.bidNo }).then(res => {
                    this.nextRoundLaod = false;
                    if (res && res.code === '0') {
                        this.$message.success('发起成功');
                        this.getData('NEXTROUND');
                    }
                });
            }).catch(() => {});
        },
        /** 开标提醒 **/
        // async startTenderCheck () {
        //     this.startTenderLoad = true
        //     // const res = await beforeWonOpenCheck({ bidNo: this.bidNo, tenderCode: this.form.tenderCode }).catch(err => { this.startTenderLoad = false })
        //     const res = await beforeWonOpenCheck({ tenderCode: this.form.tenderCode }).catch(err => { this.startTenderLoad = false })
        //     this.startTenderLoad = false
        //     if (!res || +res.code !== 0) {
        //         return Promise.reject()
        //     }
        //     if (res.data) {
        //         return this.$confirm(res.data, '开标提醒', {
        //             confirmButtonText: '确定',
        //             cancelButtonText: '取消'
        //         })
        //     } else {
        //         return Promise.resolve()
        //     }
        // },
        startTender () { /** 开标 **/
            const date = new Date(this.form.effectDateTo); // 系统返回的时间
            const result = timeStr(date);
            if (result.time - result.timestamp > 0) { // 还没到开标结束时间
                this.$confirm('剩余轮次报价结束时间还有' + result.timestr + '，是否要开标？', '开标确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    // this.startTenderCheck().then(() => { this.startTenderReq() })
                    this.startTenderReq()
                }).catch(() => {});
            } else {
                this.$confirm('本轮参与报价的供应商有' + this.form.currentSuppliers + '个，已提交报价供应商' + this.form.supplierQuote + '个，是否要开标？', '开标确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    // this.startTenderCheck().then(() => { this.startTenderReq() })
                    this.startTenderReq()
                }).catch(() => {});
            }
        },
        startTenderReq() {
            this.startTenderLoad = true;
            wonOpenAll({ tenderCode: this.form.tenderCode }).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('开标成功');
                    this.getData();
                }
            }).finally(() => { this.startTenderLoad = false; });
        },
        batchBid () { /** 分批开标 **/
            this.showBatchBidDialog = true;
        },
        /** 入围提醒 **/
        async bidShortlistCheck() {
            this.bidShortlistLoad = true
            const res = await checkDtlDetailTiedFirst(this.selectedDetails).catch(err => { this.bidShortlistLoad = false })
            this.bidShortlistLoad = false
            if (!res || +res.code !== 0) {
                return Promise.reject()
            }
            if (res.data) {
                return this.$confirm(res.data + '是否继续操作入围?', '入围提醒', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                })
            } else {
                return Promise.resolve()
            }
        },
        async bidShortlist () { /** 入围 **/
            let tipText = '';
            this.selectedDetail();
            if (this.selectedDetails.length === 0) {
                this.$message.warning('请选择报价明细');
            } else {
                for (let i = 0; i < this.selectedBtn.length; i++) {
                    if (this.selectedBtn[i].lineAmountTotal * 1 <= 0) {
                        this.$message.warning('总费用为0，不能入围');
                        return false;
                    }
                    if (this.selectedBtn[i].shortlist === '中标' || this.selectedBtn[i].shortlist === '流标' || this.selectedBtn[i].shortlist === '弃标') {
                        this.$message.warning('线路包存在中标、流标、弃标的状态，请先设置为未入围');
                        return false;
                    }
                }
                if (this.headerMsg.blockPriceControl === 'Y') {
                    const tip = await bidPriceCheck(this.selectedDetails, this.form.tenderCode);
                    if (tip && tip.code === '0' && tip.data.length !== 0) {
                        tipText = tip.data.join('</br>');
                    }
                }
                if (tipText) {
                    this.$confirm(tipText + '</br>是否要入围？', '入围确认', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        dangerouslyUseHTMLString: true,
                        customClass: 'round-message-box'
                    }).then(() => {
                        this.bidShortlistCheck().then(() => { this.bidShortlistReq() })
                    }).catch(() => {});
                } else {
                    this.bidShortlistCheck().then(() => { this.bidShortlistReq() })
                }
            }
        },
        bidShortlistReq() {
            this.bidShortlistLoad = true;
            bidWonRw(this.selectedDetails).then(res => {
                this.bidShortlistLoad = false;
                if (res && res.code === '0') {
                    this.$message.success('入围成功');
                    this.getData();
                }
            });
        },
        autoShortlist () { this.showAutoShortlist = true; }, /** 自动入围 **/
        notShortlist () { /** 未入围 **/
            this.loadNot = true;
            this.selectedDetail();
            if (this.selectedDetails.length === 0) {
                this.$message.warning('请选择报价明细');
                this.loadNot = false;
            } else {
                cancelRw(this.selectedDetails).then(res => {
                    this.loadNot = false;
                    if (res && res.code === '0') {
                        this.$message.success('成功取消入围');
                        this.getData();
                    }
                });
            }
        },
        /** 中标提醒 **/
        async winBidCheck () {
            this.winBidLoad = true
            // const quoteCode = this.selectedBtn.map(item => item.quoteCode)
            // const res = await kbzbValidate({ tenderCode: this.form.tenderCode, quoteCode }).catch(err => { this.winBidLoad = false })
            const res = await checkDtlDetailTiedFirst(this.selectedDetails).catch(err => { this.winBidLoad = false })
            this.winBidLoad = false
            if (!res || +res.code !== 0) {
                return Promise.reject()
            }
            if (res.data) {
                return this.$confirm(res.data + '是否仍要操作中标?', '中标提醒', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                })
            } else {
                return Promise.resolve()
            }
        },
        WinReq () {
            this.winBidLoad = true;
            WonZb(this.selectedDetails).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('成功更改状态为中标');
                    this.getData();
                }
            }).finally(() => { this.winBidLoad = false; });
        },
        async winBid () { /** 中标 **/
            let tipText = '';
            const obj = {};
            const extStrLine = [];
            this.selectedDetail();
            if (this.selectedDetails.length === 0) {
                this.$message.warning('请选择报价明细');
                return;
            }
            const otherTab = this.tableData.filter(item => { return item.checked !== true; });
            for (let i = 0; i < this.selectedBtn.length; i++) {
                if (this.selectedBtn[i].lineAmountTotal * 1 <= 0) {
                    this.$message.warning('总物流费用为0，不能中标');
                    return false;
                }
                obj[this.selectedBtn[i].extStr1] = [];// 总物流费用最高的判断
                obj[this.selectedBtn[i].extStr1].num = 0;
                otherTab.forEach(item2 => {
                    if (this.selectedBtn[i].extStr1 === item2.extStr1 && this.selectedBtn[i].lineAmountTotal > item2.lineAmountTotal) {
                        obj[this.selectedBtn[i].extStr1].push(true);
                        obj[this.selectedBtn[i].extStr1].num++;
                    }
                });
            }
            for (const key in obj) {
                if (obj[key].length === obj[key].num && obj[key].num !== 0) { extStrLine.push(key); }
            }
            if (extStrLine.length !== 0) { tipText = `${extStrLine.join(',')},当前预中标供应商非所选标段内总物流费用最低供应商</br>`; }
            if (this.headerMsg.blockPriceControl === 'Y') {
                const tip = await bidPriceCheck(this.selectedDetails, this.form.tenderCode);
                if (tip && tip.code === '0' && tip.data.length !== 0) {
                    tipText = tipText + tip.data.join('</br>');
                }
            }
            if (tipText) {
                this.$confirm(tipText + '</br>是否要中标？', '中标确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    dangerouslyUseHTMLString: true,
                    customClass: 'round-message-box'
                }).then(() => {
                    this.winBidCheck().then(() => { this.WinReq(); })
                }).catch(() => {});
            } else {
                this.winBidCheck().then(() => { this.WinReq(); })
            }
        },
        flowBid () { this.showWonFailedDialog = true; }, /** 流标 **/
        abandonBid () { /** 弃标 **/
            this.loadAbandon = true;
            this.selectedDetails = [];
            const table = this.tableData.filter(item => { return !item.quoteCodeParent; });
            table.forEach((item) => {
                if (item.checked === true && item.shortlist === '中标') { this.selectedDetails.push({ id: item.id }); }
            });
            if (!this.selectedDetails.length) {
                this.loadAbandon = false;
                this.$message.warning('请选择中标状态为中标的报价明细');
            } else {
                wonGiveUp(this.selectedDetails).then(res => {
                    this.loadAbandon = false;
                    if (res && res.code === '0') {
                        this.$message.success('成功弃标');
                        this.getData();
                    }
                });
            }
        },
        saveDteails () { /** 明细保存 **/
            this.loadSave = true;
            this.tableLoad = true;
            const tableList = [];
            const table = this.tableData.filter(item => { return !item.quoteCodeParent; });
            const tableCopy = JSON.parse(JSON.stringify(table));// 深拷贝
            tableCopy.forEach(item => {
                if (item.children) { item.children.forEach(it => { tableList.push(it); }); }
                delete item.children;
                tableList.push(item);
            });
            saveDetailsMsg(tableList, this.form.tenderCode).then(res => {
                this.loadSave = false;
                this.tableLoad = false;
                if (res && res.code === '0') {
                    this.$message.success('保存成功');
                    this.getData();
                }
            });
        },
        handleCommand (command) {
            // window.location = config.apiUrl + command.url + this.form.tenderCode + '/' + command.allowQuote;
            // window.location = 'https://luatapi.midea.com' + command.url + this.form.tenderCode + '/' + command.allowQuote;
            this[command.loading] = true;
            exportBidTender(command.url, this.form.tenderCode, command.allowQuote).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.data);
                }
            }).finally(() => { this[command.loading] = false; });
            if (command.bigData) {
                bigDataLog.sendDetailMessageByKey(command.bigData);
            }
        },
        selectData () { /** 查询 **/
            if (!this.form.tenderCode) { return false; }
            this.tableLoad = true;
            let extStr1s = [];
            const that = this;
            if (that.extStr1s) {
                extStr1s = that.extStr1s.replaceAll('，', ',').split(',');
            }
            const params = {
                tenderCode: that.form.tenderCode,
                extStr1s: extStr1s,
                allowQuote: that.allowQuote,
                tenderStatus: that.tenderStatus,
                shortlist: that.shortlist,
                supplierName: that.supplierName,
                parent: true
            };
            getManageDetails(params).then(res => {
                if (res && res.code === '0') {
                    that.tableData = res.data;
                    that.tableData = that.formatData(that.tableData);
                    that.tableData.forEach((single) => {
                        this.$set(single, 'showSubTable', false);
                    });
                }
            }).finally(() => { this.tableLoad = false; });
        },
        btnChange () { /** 按钮状态控制 **/
            if (this.form.tenderStatus !== this.TENDER_STATUS['NEW'] || this.headerMsg.bidStatus === this.BID_STATUS['STAMP']) {
                this.statusBtn = true;
            } else { this.statusBtn = false; }
            if (this.form.tenderStatus !== this.TENDER_STATUS['PUBILSH'] || this.headerMsg.bidStatus === this.BID_STATUS['STAMP']) {
                this.timeBtn = true;
            } else { this.timeBtn = false; }
            if (this.form.tenderStatus !== this.TENDER_STATUS['OPEN'] || this.headerMsg.bidStatus === this.BID_STATUS['STAMP']) {
                this.nextBtn = true;
            } else { this.nextBtn = false; }
        },
        formatData (data) { return formatData(data, this.dictData); },
        selectedDetail () {
            this.selectedDetails = [];
            this.selectedBtn = [];
            const table = this.tableData.filter(item => { return !item.quoteCodeParent; });
            table.forEach((item) => {
                if (item.checked === true) {
                    this.selectedDetails.push({ id: item.id });
                    this.selectedBtn.push(item);
                }
            });
        },
        getQuoteType (val) { this.form.quoteType = val; },
        getLowerLastRound (val) {
            this.form.lowerLastRound = val;
            if (this.form.lowerLastRound === this.LOWER_LAST_ROUND['BYPACKAGE']) { this.form.changeBidMin = 0; }
        },
        getRankVisible (val) { this.form.rankVisible = val; },
        getLowestQuoteVisible (val) { this.form.lowestQuoteVisible = val; },
        getAllowQuote (val) { this.allowQuote = val; },
        getTenderStatus (val) { this.tenderStatus = val; },
        getShortlist (val) { this.shortlist = val; },
        selectAllChange (val, selectedRow) {
            this.selectAllType = val;
            this.selectedRow = selectedRow;
        },
        loadFn (val) { this.tableLoad = val; },
        checkCostJud (val) { return !val.showSubTable; },
        checkCost () { // 查看参考成本，先弹出客户选框
            if (this.selectedRow.length > 0) {
                const temp = !this.selectedRow.every(this.checkCostJud);
                if (temp) {
                    this.showCustem = true;
                    this.$refs.customAdvance.show(true, customConfig);
                } else {
                    this.$message.warning('请选择子数据！');
                }
            } else {
                this.$message.warning('至少选择一条数据！');
            }
        },
        custemConfirm (custom) { // 选择客户，弹出参考成本表格
            this.showConsultCostDialog = true;
            this.consultCostParams = parFn(custom, this.selectedRow, this.loginState);
        },
        linkDockModel () { setTimeout(() => { this.$router.push('/dockModel'); }, '200'); },
        getBlockPriceControl (val) { 
            this.form.blockPriceControl = val;
            if(val === 'Y'){
                this.$alert('点击【公布拦标价】按钮才能进行功能生效，否则无法进行拦标！', '提示', {
                    confirmButtonText: '确定',
                });
            }
        },
        initWebSocket() { // 初始化weosocket
            const { userCode } = this.user;
            const protocol = location.protocol === 'http:' ? 'ws:' : 'wss:';
            const wsuri = `${protocol}//${config.apiUrl}/api-srm-websocket/websocket/${userCode}/${this.form.tenderCode}`;
            this.websock = new WebSocket(wsuri);
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
        },
        heartCheck() {
            this.IS_WS_LIVE_TIMER = setTimeout(() => {
                if (this.websock.readyState === 1) {
                    this.websocketsend();
                    this.IS_WS_TIMEOUT_TIMER = setTimeout(() => {
                        this.websock && this.websock.close();
                        this.$message.error('网络异常或者服务器断开websocket连接！正在重连！');
                        this.initWebSocket();
                    }, '10000');
                }
            }, '30000');
        },
        resetInter() {
            this.IS_WS_LIVE_TIMER && clearTimeout(this.IS_WS_LIVE_TIMER);
            this.IS_WS_TIMEOUT_TIMER && clearTimeout(this.IS_WS_TIMEOUT_TIMER);
            return this;
        },
        websocketonopen() { // 连接建立之后执行send方法发送数据
            this.resetInter().heartCheck();
        },
        websocketonerror(e) { // 连接建立失败重连
            // this.initWebSocket();
        },
        websocketonmessage(e) { // 数据接收
            const redata = JSON.parse(e.data);
            // 校验是否在其他地方有登陆，有登陆的踢出账号，重新登陆
            if (!(redata.code === '0' || redata.code === '200')) {
                this.$message.error(redata.msg);
                setTimeout(() => { logout(); }, '5000');
                return;
            }
            // 数据处理
            if (e.data.indexOf('body') > -1) {
                const body = redata.body;
                if (redata.relationCode === this.form.tenderCode && body && body.effectDateToTime && body.effectDateToTime > 0) {
                    this.cuuntdownSeconds = body.effectDateToTime / 1000;
                    this.setIntervalTime && clearTimeout(this.setIntervalTime);
                    this.setCountTime();
                    this.currentList = (body && body.list) || [];
                }
            }
            // 心跳
            this.resetInter().heartCheck();
        },
        websocketsend() { // 数据发送
            this.websock.send('ping');
        },
        websocketclose(e) { // 关闭
            this.resetInter();
            this.websock && this.websock.close();
        },
        handleMatchStandardCost() {
            this.standardCostLoading = true;
            matchStandardCosts(this.form.tenderCode).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('匹配成功');
                }
            }).finally(() => { this.standardCostLoading = false; });
        }
    },
    mounted () {
        this.bidNo = this.$route.query.bidNo;
        dictWithUrl('BID_SU_TENDER_STATUS,BID_LOWER_LAST_ROUND,BID_YES_NO,BID_SU_TENDER_TYPE,BID_WON_STATUS').then(res => {
            this.dictData = res.data;
            this.getData('NEXTROUND');
        });
        bigDataLog.sendDetailMessageByKey('bigData-btn-roundquote');
    },
    computed: {
        ...mapGetters(['user']),
        loginState: function () { return this.$store.state.bidData; },
        standardCostVisible: function () {
            const { businessType } = this.$store.state.bidData;
            return !!businessType && [TRANSPORTATION_NUM, DELIVERY_NUM, EXPRESS_NUM, HOME_DELIVERY_NUM].includes(businessType);
        }
    }
};
